"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VictoryChart = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _reactNativeSvg = require("react-native-svg");

var _es = require("victory-chart/es");

var _background = require("./victory-primitives/background");

var _victoryAxis = require("./victory-axis");

var _victoryPolarAxis = require("./victory-polar-axis");

var _victoryContainer = require("./victory-container");

var _wrapCoreComponent = require("../helpers/wrap-core-component");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VictoryChart = (0, _wrapCoreComponent.wrapCoreComponent)({
  Component: _es.VictoryChart,
  defaultProps: {
    backgroundComponent: /*#__PURE__*/_react.default.createElement(_background.Background, null),
    containerComponent: /*#__PURE__*/_react.default.createElement(_victoryContainer.VictoryContainer, null),
    groupComponent: /*#__PURE__*/_react.default.createElement(_reactNativeSvg.G, null),
    defaultAxes: {
      independent: /*#__PURE__*/_react.default.createElement(_victoryAxis.VictoryAxis, null),
      dependent: /*#__PURE__*/_react.default.createElement(_victoryAxis.VictoryAxis, {
        dependentAxis: true
      })
    },
    defaultPolarAxes: {
      independent: /*#__PURE__*/_react.default.createElement(_victoryPolarAxis.VictoryPolarAxis, null),
      dependent: /*#__PURE__*/_react.default.createElement(_victoryPolarAxis.VictoryPolarAxis, {
        dependentAxis: true
      })
    },
    prependDefaultAxes: true,
    width: _reactNative.Dimensions.get("window").width
  }
});
exports.VictoryChart = VictoryChart;